import { NavigateNext } from '@styled-icons/material';
import { mobileCutoff } from 'apps/exegesis/styles/themes';
import { AuthContext } from 'libs/shared-firebase/src';
import Link from 'next/link';
import React, { FunctionComponent, useContext } from 'react';
import styled from 'styled-components';
import create from 'zustand';
import { NSOffline, NSOnline } from '../StatusUI/NetworkStatusComponents';
import SidebarNoteDisplay from './SidebarNoteDisplay';

const minimalistic = '/minimalistic.png';

export const useMenu = create((set) => ({
  menuOpen: true,
  //@ts-ignore
  setMenuOpen: (newMenuState: boolean) => set({ menuOpen: newMenuState }),
}));

const NotesWrapper: FunctionComponent<any> = ({ children }) => {
  const { menuOpen, setMenuOpen } = useMenu();
  const user = useContext(AuthContext);

  if (!user || user.loggedInUser === null) {
    return (
      <UnauthorizedContainer>
        <h1>you need to be logged in</h1>
        <Link passHref href="/login">
          <LoginText>login</LoginText>
        </Link>
        <br />
      </UnauthorizedContainer>
    );
  }

  return (
    <NotesContainer>
      <MenuContainer style={{ display: menuOpen ? 'flex' : 'none' }}>
        <SidebarNoteDisplay menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      </MenuContainer>
      {menuOpen ? null : (
        <CollapseButton
          open={menuOpen}
          onClick={() => {
            setMenuOpen(true);
          }}
        >
          <NavigateNext height="20px" />
        </CollapseButton>
      )}
      <ContentContainer>
        <NSOnline>{children}</NSOnline>
        <NSOffline>
          <div style={{ padding: '5vw' }}>
            <h1>You&apos;re offline</h1>
            <p>Please check your connection.</p>{' '}
          </div>
        </NSOffline>
      </ContentContainer>
    </NotesContainer>
  );
};
const LoginText = styled.button`
  font-size: 20px;
  margin-top: 10px;
  padding: 5px;
  background: none;
  border: 1px solid black;
  :hover {
    background-color: grey;
  }
`;

const UnauthorizedContainer = styled.div`
  padding: 5vw;
`;
const NotesContainer = styled.div`
  display: flex;
  align-content: stretch;
  height: 100vh;
  width: 100vw;

  background-color: ${(props) => props.theme.backgroundColor || 'white'};
  /* scrollbar-color: ${(props) => props.theme.backgroundColor || 'white'}; */
`;

const MenuContainer = styled.aside`
  overflow: auto;
  width: 300px;
  height: 100vh;
  border-right: 1px solid grey;

  display: flex;
  flex-flow: column;
  @media only screen and (max-width: ${mobileCutoff}) {
    background-color: ${(props) => props.theme.backgroundColor || 'white'};
    z-index: 10000000;
    position: absolute;
    width: 100vw;
    border-right: none;
  }
`;

const ContentContainer = styled.div`
  overflow: auto;
  flex-grow: 1;
  min-width: 50vw;
  width: 75vw;
  height: 100%;
  @media only screen and (max-width: ${mobileCutoff}) {
    /* z-index: -1; */
    /* position: absolute; */
    width: 100vw;
  }
`;

export const CollapseButton = styled.button<{ open: boolean }>`
  background-color: transparent;
  border: none;
  float: right;
  position: ${(props) => {
    if (!props.open) {
      return 'absolute';
    } else return 'static';
  }};
  top: 15px;
  left: 15px;
  padding: ${(props) => {
    if (!props.open) {
      return '0px';
    } else return '2px';
  }};
  margin: ${(props) => {
    if (!props.open) {
      return '0px';
    } else return '3px';
  }};
  color: rgb(68, 68, 68);

  :hover {
    color: ${(props) => props.theme.colors.main.dark};
    cursor: pointer;
  }
  z-index: 101;
`;

export default NotesWrapper;
